.modalBody {
  width: 650px !important;
}

.content {
  display: flex;
  gap: 30px;
}

.settings {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 17px;
  flex: 1 0 0;
  // Allow the column to shrink below its content's min width; without this the
  // fullWidth campaign trigger (nowrap) forces the whole modal wider and overflows.
  min-width: 0;

  .setting {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    width: 100%;
    min-width: 0;
  }
}
